/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.container {
  display: flex;
  align-items: center;
  gap: calc(var(--spacing, 0.25rem) * 4);
  padding: calc(var(--spacing, 0.25rem) * 2);
}
